import Vue from 'vue'
import VueRouter from 'vue-router'
import Library from '../views/Library.vue'
import NotFound from '../views/NotFound.vue'
import Section from '../views/Section.vue'


Vue.use(VueRouter)

const routes = [{
    path: '/',
    redirect: '/bibliotecas'
  },
  {
    path: '/bibliotecas',
    name: 'bibliotecas',
    component: Library,
  },
  {
    path: '/seccion',
    name: 'seccion',
    component: Section
  },
  {
    path: '/*',
    name: 'not_found',
    component: NotFound
  },
]

const router = new VueRouter({
  base: process.env.BASE_URL,
  mode: 'history',
  routes
})

export default router